import DOMPurify from 'isomorphic-dompurify'

const MAX_CACHE_ENTRIES = 500

// Every departure of a ship renders the same description, and sanitizing is expensive (jsdom on the server)
function memoize (sanitize: (html: string) => string): (html: string) => string {
  const cache = new Map<string, string>()
  return (html) => {
    const cached = cache.get(html)
    if (cached != null) {
      return cached
    }
    const result = sanitize(html)
    if (cache.size >= MAX_CACHE_ENTRIES) {
      cache.clear()
    }
    cache.set(html, result)
    return result
  }
}

export const cleanHTML = memoize((html) => DOMPurify.sanitize(html, {
  ALLOWED_TAGS: ['b', 'i', 'u', 'p', 'br', 'a', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href']
}))

export const stripHTML = memoize((html) => DOMPurify.sanitize(html, {
  ALLOWED_TAGS: [],
  ALLOWED_ATTR: []
}))

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName.toLowerCase() === 'a') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noreferrer noopener')
    node.classList.add('text-brand-primary')
    node.classList.add('hover:text-brand-primary-hover')
    node.classList.add('underline')
    if (node.textContent.includes('https://') || node.textContent.includes('http://')) {
      node.classList.add('break-all')
    }
  } else if (node.tagName.toLowerCase() === 'ul') {
    node.classList.add('list-disc')
    node.classList.add('list-inside')
  }
})
